class ModuleRegistry {
  /**
   * Registers the modules to core
   * @param moduleName name of the module
   * @param module module exposed apis
   * @param pcore pCore instance
   */
  static registerModule(moduleName: string, module: object, pcore: any) {
    pcore[moduleName] = () => module;
  }
}

export default ModuleRegistry;
